import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

// @ts-expect-error Argument of type '{ root: PreloadableJSResourceReference<FC<RefAttributes<unknown>>>; getPreloadProps: () => {}; }' is not assignable to parameter of type 'never'
export const getStartedListNudgeEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-get-started-list-entrypoint" */ './index'),
	),
	getPreloadProps: () => ({}),
});
